import { combineReducers } from 'redux'
import request from 'utils/request'
import { getPasswordError, addErrorClass } from 'utils/misc'
import { authActions } from 'store/user'
import { actions as loginActions } from '../../Login/modules/Login'

const PARTICIPANT_RESTARTED = 'PARTICIPANT_RESTARTED'
const SHOW_CHANGE_PASSWORD = 'SHOW_CHANGE_PASSWORD'
const UPDATE_NEW_PASSWORD = 'UPDATE_NEW_PASSWORD'
const RESET_PW_STATE = 'RESET_PW_STATE'
const SET_PASSWORD_ERROR = 'SET_PASSWORD_ERROR'
const CLEAR_PASSWORD_ERROR = 'CLEAR_PASSWORD_ERROR'

function resetPasswordState() {
  return {
    type: RESET_PW_STATE
  }
}

function updatePassword(field, value) {
  return {
    type: UPDATE_NEW_PASSWORD,
    field,
    value
  }
}

const setPasswordError = (response, payload) => {
  return { type: SET_PASSWORD_ERROR, payload }
}

const clearPasswordError = () => {
  return { type: CLEAR_PASSWORD_ERROR }
}

const generateBlankPWState = () => {
  return {
    newPassword: '',
    newPasswordConfirmation: ''
  }
}

const restartParticipant = (token, resetPw = false) => {
  return dispatch => {
    // const success = jsonBody => {
    //   const payload = Object.assign(
    //     JSON.parse(atob(jsonBody.token.split('.')[1])),
    //     jsonBody,
    //   )
    //   if (!payload.username || !payload.id) {
    //     navigateTo('/unauthorized')
    //     throw new Error('Unable to authenticate user ')
    //   }
    //   if (jsonBody.hasPassword && !resetPw) {
    //     navigateTo('/profile')
    //     throw new Error('You have already set your password')
    //   }
    //   dispatch({
    //     type: PARTICIPANT_RESTARTED,
    //     token: jsonBody.token,
    //   })
    // }
    // return dispatch(
    //   request({
    //     method: 'POST',
    //     url: '/control/participants/verify_token',
    //     body: JSON.stringify({ token }),
    //     failMessage: 'Unable to authenticate user.',
    //     success,
    //     authRequired: false,
    //     headerOptions: {
    //       Authorization: token,
    //     },
    //   }),
    // )
    dispatch({
      type: PARTICIPANT_RESTARTED,
      token
    })
    return Promise.resolve(token)
  }
}

function setNewPasswordWithToken(passwordState, token) {
  return (dispatch, getState) => {
    const { strings } = getState()
    const passwordError = getPasswordError(
      passwordState.password,
      passwordState.password_confirmation,
      dispatch,
      strings
    )
    if (!passwordError) {
      const success = () => {
        dispatch(clearPasswordError())
        dispatch(loginActions.clearTempPassword())
        dispatch(authActions.changedPassword())
      }
      return dispatch(
        request({
          method: 'POST',
          url: `/control/setup_password`,
          body: JSON.stringify(Object.assign({}, passwordState, { token })),
          successMessage: 'Password set successfully',
          success,
          authRequired: false,
          headerOptions: {
            Authorization: token
          },
          fail: setPasswordError
        })
      )
    }
    addErrorClass(['user-password', 'user-password-confirmation'])
  }
}

const ptpToken = (state = null, action) => {
  switch (action.type) {
    case PARTICIPANT_RESTARTED:
      return action.token
    default:
      return state
  }
}

const restartPassword = (state = generateBlankPWState(), action) => {
  switch (action.type) {
    case RESET_PW_STATE: {
      return generateBlankPWState()
    }
    case UPDATE_NEW_PASSWORD: {
      return Object.assign({}, state, { [action.field]: action.value })
    }
    default: {
      return state
    }
  }
}

const passwordError = (state = null, action) => {
  switch (action.type) {
    case SET_PASSWORD_ERROR: {
      return action.payload
    }
    case CLEAR_PASSWORD_ERROR:
      return null
    default:
      return state
  }
}

export const actions = {
  restartParticipant,
  setNewPasswordWithToken,
  updatePassword,
  resetPasswordState,
  clearPasswordError
}

export default combineReducers({ ptpToken, passwordError, restartPassword })
